export const projectsData = [
  {
    "id": 1,
    "title": "Amurta Hospital",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "TypeScript"
    ],
    "github": "https://github.com/gokulakannan69/Amurta-Hospital",
    "link": "https://github.com/gokulakannan69/Amurta-Hospital"
  },
  {
    "id": 2,
    "title": "Customer Business Management System",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "JavaScript"
    ],
    "github": "https://github.com/gokulakannan69/Customer-Business-Management-System",
    "link": "https://github.com/gokulakannan69/Customer-Business-Management-System"
  },
  {
    "id": 3,
    "title": "E_Commerce",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "JavaScript"
    ],
    "github": "https://github.com/gokulakannan69/E_Commerce",
    "link": "https://github.com/gokulakannan69/E_Commerce"
  },
  {
    "id": 4,
    "title": "FusionAI_Extension_VSCode",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "TypeScript"
    ],
    "github": "https://github.com/gokulakannan69/FusionAI_Extension_VSCode",
    "link": "https://github.com/gokulakannan69/FusionAI_Extension_VSCode"
  },
  {
    "id": 5,
    "title": "gokulakannan69",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "JavaScript"
    ],
    "github": "https://github.com/gokulakannan69/gokulakannan69",
    "link": "https://github.com/gokulakannan69/gokulakannan69"
  },
  {
    "id": 6,
    "title": "HandSpeak Sign in Language",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "Python"
    ],
    "github": "https://github.com/gokulakannan69/HandSpeak-Sign-in-Language",
    "link": "https://github.com/gokulakannan69/HandSpeak-Sign-in-Language"
  },
  {
    "id": 7,
    "title": "heart disease prediction",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "TypeScript"
    ],
    "github": "https://github.com/gokulakannan69/heart-disease-prediction",
    "link": "https://github.com/gokulakannan69/heart-disease-prediction"
  },
  {
    "id": 8,
    "title": "hospital_management",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "TypeScript"
    ],
    "github": "https://github.com/gokulakannan69/hospital_management",
    "link": "https://github.com/gokulakannan69/hospital_management"
  },
  {
    "id": 9,
    "title": "Library management",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "JavaScript"
    ],
    "github": "https://github.com/gokulakannan69/Library-management",
    "link": "https://github.com/gokulakannan69/Library-management"
  },
  {
    "id": 10,
    "title": "machinetest",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "Python"
    ],
    "github": "https://github.com/gokulakannan69/machinetest",
    "link": "https://github.com/gokulakannan69/machinetest"
  },
  {
    "id": 11,
    "title": "payroll_management",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "JavaScript"
    ],
    "github": "https://github.com/gokulakannan69/payroll_management",
    "link": "https://github.com/gokulakannan69/payroll_management"
  },
  {
    "id": 12,
    "title": "portfolio",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "JavaScript"
    ],
    "github": "https://github.com/gokulakannan69/portfolio",
    "link": "https://github.com/gokulakannan69/portfolio"
  },
  {
    "id": 13,
    "title": "RAG",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "Python"
    ],
    "github": "https://github.com/gokulakannan69/RAG",
    "link": "https://github.com/gokulakannan69/RAG"
  },
  {
    "id": 14,
    "title": "TECH_SLM",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "Jupyter Notebook"
    ],
    "github": "https://github.com/gokulakannan69/TECH_SLM",
    "link": "https://github.com/gokulakannan69/TECH_SLM"
  },
  {
    "id": 15,
    "title": "VIPSYSTEMS MOBILE APPLICATION",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "Dart"
    ],
    "github": "https://github.com/gokulakannan69/VIPSYSTEMS-MOBILE-APPLICATION",
    "link": "https://github.com/gokulakannan69/VIPSYSTEMS-MOBILE-APPLICATION"
  },
  {
    "id": 16,
    "title": "Women Safety",
    "description": "A comprehensive project developed with modern web technologies.",
    "tech": [
      "TypeScript"
    ],
    "github": "https://github.com/gokulakannan69/Women-Safety",
    "link": "https://github.com/gokulakannan69/Women-Safety"
  }
];